'use client';
import { cn } from '@bazaar-marketplace/utils';
import { useNavigationConfig } from './navigation-config';
import { NavigationItem } from './navigation-item';
import { Sheet, SheetContent } from '../ui/sheet';
import { PartnerMarketplacesSheet } from '~/module/pack/partner-marketplaces-sheet';

export const Navigation = () => {
  const { routes, marketSheetOpen, setMarketSheetOpen, isVisible } = useNavigationConfig();

  if (!isVisible) {
    return null;
  }

  return (
    <nav className="bg-black fixed bottom-0 left-0 right-0 px-4 pb-[29px] min-size-8 pt-2 flex z-50">
      {marketSheetOpen ? (
        <Sheet open={marketSheetOpen} onOpenChange={setMarketSheetOpen}>
          <SheetContent className="rounded-t-3xl">
            <PartnerMarketplacesSheet />
          </SheetContent>
        </Sheet>
      ) : null}

      {routes.map(({ href, icon, text, disabled, onClick }) => (
        <NavigationItem
          key={text}
          className={cn(`w-1/${routes.length}`, 'flex-1')}
          disabled={disabled}
          href={href}
          icon={icon}
          text={text}
          onClick={onClick}
        />
      ))}
    </nav>
  );
};
